/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable sonarjs/cognitive-complexity */
import { AccountVariationsConfig } from '@nizza/core';
import {
  ComponentChildSchema,
  withCustomizeSchema,
} from '@nizza/customize-live';
import { formatCurrency } from '@nizza/utils';
import { SettingContext, useSettings } from 'lib/context';
import { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { CSSTransition, Transition } from 'react-transition-group';
import { useVariationsConfig } from '../../../hooks';
import { useFetchProductById } from '../../../hooks/useFetchProductById';
import type { PlayerProduct, PlayerVariationValues } from '../../../types';
import { intlFormatMessageOutsideFC } from '../../../utils/intlFormatMessageOutsideFC';
import { ProductButton } from '../../ProductsButton/ProductButton';
import { ColorVariation } from '../color-variation';
import { SizeVariations } from '../size-variation';
import ModalContent from './modal-content.component';
import { ModalOverlay } from './modal-overlay.component';
import styles from './styles.module.css';

const intl = intlFormatMessageOutsideFC();

type VariationSelectorProps = {
  showVariation: string;
  setShowVariation: React.Dispatch<React.SetStateAction<string>>;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export const Modal = (props: VariationSelectorProps) => {
  const { showVariation, setShowVariation } = props;
  const { infoSocket, variationThumbnailName } = useContext(SettingContext);
  const { showTax } = infoSocket || {};
  const [productId, setProductId] = useState('');
  const [show, setShow] = useState(false);
  const [selectedColor, setSelectedColor] = useState<PlayerVariationValues[]>();
  const [selectedSize, setSelectedSize] = useState<PlayerVariationValues[]>();
  const [isAvailable, setIsAvailable] = useState(true);
  const { formatMessage } = useIntl();
  const { accountCurrencyConfig } = useSettings();
  const { variationsConfig } = useVariationsConfig();

  const [selectedProduct, setSelectedProduct] = useState({
    imageUrl: '',
    addToCartLink: '',
    isAvailable: true,
    price: 0,
    priceWithDiscount: 0,
    skuId: '',
  });

  const { product, loading } = useFetchProductById({
    productId,
  });

  useEffect(() => {
    if (showVariation) setProductId(showVariation);
  }, [showVariation]);

  useEffect(() => {
    if (loading) {
      setShow(loading);
    }
  }, [loading]);

  useEffect(() => {
    setIsAvailable(true);

    const selectedVariations = selectedColor
      ? selectedColor?.concat(selectedSize || [])
      : selectedSize;

    let filterProduct = product?.items;
    let isVariation = '';
    const productSelect = selectedVariations?.map(variation => {
      const items = filterProduct?.filter(item => {
        isVariation = (item as any)[variation.variationName || ''];

        if (isVariation) {
          return (
            (item as any)[variation.variationName || ''][0] === variation?.name
          );
        }

        return false;
      });

      if (items?.length) {
        filterProduct = items;
      } else {
        if (isVariation) setIsAvailable(false);
      }

      return filterProduct;
    });

    if (productSelect) {
      const selectedProduct = filterProduct?.map(filter => {
        const seller = filter.sellers[0];

        const priceWithDiscount = !showTax
          ? seller?.commertialOffer.Price
          : (seller?.commertialOffer.Price ?? 0) +
          (seller?.commertialOffer?.Tax ?? 0);

        const price = !showTax
          ? seller?.commertialOffer.ListPrice
          : (seller?.commertialOffer.ListPrice ?? 0) +
          (seller?.commertialOffer?.Tax ?? 0);

        return {
          imageUrl: filter.images[0].imageUrl,
          addToCartLink: seller.addToCartLink,
          isAvailable: seller.commertialOffer.IsAvailable,
          price,
          priceWithDiscount,
          skuId: filter.itemId,
        };
      });

      if (selectedProduct) setSelectedProduct(selectedProduct[0]);
    }
  }, [selectedColor, selectedSize]);

  useEffect(() => {
    if (!product?.variationSelector) {
      const selectedProduct = product?.items?.map(filter => {
        return {
          imageUrl: filter.images[0].imageUrl,
          addToCartLink: filter.sellers[0].addToCartLink,
          isAvailable: filter.sellers[0]?.commertialOffer.IsAvailable,
          price: filter.sellers[0]?.commertialOffer.ListPrice,
          priceWithDiscount: filter.sellers[0]?.commertialOffer.Price,
          skuId: filter.itemId,
        };
      });

      if (selectedProduct) setSelectedProduct(selectedProduct[0]);
    } else if (product.variationSelector.length === 0) {
      setSelectedProduct({
        imageUrl: product.imageUrl,
        addToCartLink: product.addToCartLink,
        isAvailable: product.isAvailable,
        price: product.price,
        priceWithDiscount: product.priceWithDiscount,
        skuId: product.id,
      });
    }
  }, [product]);

  const handleClose = () => {
    setShow(false);
    setShowVariation('');
    setProductId('');
    setSelectedSize([]);
    setSelectedColor([]);
  };
  // FIXME this is hardcode => const showBackIcon = props.type === 'quickview' && isMobile && fromDrawerProduct
  const showBackIcon = false;

  const handleOnClickBack = () => {
    // FIXME this do something - review
    // actionsCustomQuickView(props.type, false)
    handleClose();
  };

  const productFormate = {
    id: product?.id || '',
    name: product?.name || '',
    price: selectedProduct.price,
    priceWithDiscount: selectedProduct.priceWithDiscount,
    imageUrl: selectedProduct.imageUrl,
    addToCartLink: selectedProduct.addToCartLink,
    items: product?.items || [],
    isAvailable: isAvailable ? selectedProduct.isAvailable : false,
    variationSelector: product?.variationSelector || [],
    pdpLink: product?.pdpLink || '',
    skuId: selectedProduct.skuId,
  };

  return (
    // TODO add nice transition and warning in console logs
    <Transition in={show}>
      <CSSTransition in={show} unmountOnExit>
        <ModalOverlay
          closeOnOverlayClick
          onClose={handleClose}
          backgroundColor="transparent"
          isOpen={show}
        >
          <ModalContent
            type={'quickview'}
            containerClassName="h-100 fixed right-0-ns bottom-0 pb4 pre"
            showCloseIcon={!showBackIcon}
            showBackIcon={showBackIcon}
            onClose={handleClose}
            onClickBack={handleOnClickBack}
          >
            <div className={styles.productPictureContainer}>
              <img
                className={styles.productPicture}
                src={selectedProduct.imageUrl}
                alt="product"
              />
            </div>
            <div className={styles.productDetailInfo}>
              <div className={styles.productContainer}>
                <div className={styles.productInfo}>
                  <h2 className={styles.productTitle}>{product?.name}</h2>
                  <span>
                    {selectedProduct?.price !==
                      selectedProduct?.priceWithDiscount && (
                        <span className={styles.productPrice}>
                          {formatCurrency(
                            selectedProduct?.price,
                            accountCurrencyConfig,
                          )}
                        </span>
                      )}
                  </span>
                  <span className={styles.productDiscountPrice}>
                    {formatCurrency(
                      selectedProduct?.priceWithDiscount,
                      accountCurrencyConfig,
                    )}
                  </span>
                </div>
              </div>

              <SelectProductVariations
                show={show}
                product={product}
                setSelectedColor={setSelectedColor}
                variationThumbnailName={variationThumbnailName}
                setSelectedSize={setSelectedSize}
                selectedSize={selectedSize}
                variationsConfig={variationsConfig}
              />

              <div className={styles.linkPdpContainer}>
                <a
                  href={product?.pdpLink || '#'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.linkPdp}
                >
                  {formatMessage({ id: 'store/text.details' })}
                </a>
              </div>

              <div className={styles.productContainer}>
                <div className={styles.variationContent}>
                  <div className={styles.productAddCartContent}>
                    <div className={styles.buttonGroup}>
                      <ProductButton
                        product={productFormate}
                        handleClose={handleClose}
                        variationSelectorState={[
                          showVariation,
                          setShowVariation,
                        ]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalContent>
        </ModalOverlay>
      </CSSTransition>
    </Transition>
  );
};

type SelectProductVariations = {
  show: boolean;
  setSelectedColor: React.Dispatch<
    React.SetStateAction<PlayerVariationValues[] | undefined>
  >;
  setSelectedSize: React.Dispatch<
    React.SetStateAction<PlayerVariationValues[] | undefined>
  >;
  product?: PlayerProduct;
  variationThumbnailName?: string;
  selectedSize?: PlayerVariationValues[];
  variationsConfig?: AccountVariationsConfig;
};

const SelectProductVariations = withCustomizeSchema(
  ({
    selector,
    formData,
    show,
    product,
    setSelectedColor,
    variationThumbnailName,
    setSelectedSize,
    selectedSize,
    variationsConfig,
  }: ComponentChildSchema<SelectProductVariations>) => {
    return (
      <div className={styles.productContainer} customize-field={selector}>
        {show &&
          product &&
          product.variationSelector &&
          product.variationSelector?.length > 0 ? (
          <div className={styles.variationContent}>
            <ColorVariation
              product={product || []}
              setSelectedColor={setSelectedColor as any}
              variationThumbnailName={variationThumbnailName}
              roundOrSquareSelector={formData?.data?.roundOrSquareSelector}
              variationsConfig={variationsConfig}
            />
          </div>
        ) : null}

        {show &&
          product &&
          product.variationSelector &&
          product.variationSelector?.length > 0 ? (
          <SizeVariations
            product={product || []}
            setSelectedSize={setSelectedSize as any}
            selectedSize={selectedSize || []}
            roundOrSquareSelector={formData?.data?.roundOrSquareSelector}
            variationsConfig={variationsConfig}
          />
        ) : null}
      </div>
    );
  },
  {
    products: {
      id: 'select_product_variations_trigger',
      label: intl.formatMessage({
        id: 'customize/modal-trigger.select-product-variations.title',
      }),
      category: 'mix',
      fields: {
        type: 'object',
        properties: {
          roundOrSquareSelector: {
            type: 'string',
            title: intl.formatMessage({
              id: 'customize/modal-trigger.round-or-square-selector',
            }),
            oneOf: [
              {
                const: 'square-selector',
                title: intl.formatMessage({
                  id: 'customize/modal-trigger.square-selector',
                }),
              },
              {
                const: 'round-selector',
                title: intl.formatMessage({
                  id: 'customize/modal-trigger.round-selector',
                }),
              },
            ],
            default: 'square-selector',
          },
        },
      },
      ui: {
        roundOrSquareSelector: {
          'ui:widget': 'radio',
          'ui:options': {
            inline: false,
          },
        },
      },
    },
  },
);
